module.exports = __webpack_public_path__ + "static/media/47.2cf09b5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/47.jpg
// module id = 307
// module chunks = 0